var collapsible_list_component_rtlignore_default = {
  "ltr": "VVBD6",
  "rtl": "ifUr0",
  "iconContainer": "_0E5Ee",
  "icon": "vXLwX",
  "isExpanded": "QDtZc",
  "listDimensions": "_44RNy"
};
export {
  collapsible_list_component_rtlignore_default as default
};
//# sourceMappingURL=collapsible-list-component.rtlignore-scss.js.map
